import { ScheduleScrollHelper } from '@/services/store/schedule/types/types';

const scrollingQueue: (() => void)[] = [];

export function useQueueFunctionsAfterScroll() {
  const queueFunctionAfterScroll = (fn: () => void, scrollHelper: ScheduleScrollHelper): void => {
    if (scrollHelper.isScrolling) {
      scrollingQueue.push(fn);
    } else {
      fn();
    }
  };

  const executeAfterScrollFunctions = (): void => {
    if (scrollingQueue.length > 0) {
      scrollingQueue.forEach((fn) => fn());
      scrollingQueue.length = 0;
    }
  };

  return {
    queueFunctionAfterScroll,
    executeAfterScrollFunctions,
  };
}
